module.exports = __webpack_public_path__ + "static/14-Small dish w:loose leaves-4df9797c7897c9599bd4b38b43d95641.jpg";